/**
 * AI / LLM work shown in the "AI" section as compact cards.
 * `status`: 'Built' | 'In production' | 'AI use case' (only claim what is true).
 * `kind`: small label above the title. Keep `summary` to one short sentence: cards are compact.
 */
export const aiProjects = [
  {
    id: 'procurement',
    status: 'Built',
    kind: 'Procurement',
    title: 'AI Procurement Platform',
    summary:
      'Contract summaries, contract criteria, bid proposals and a system chatbot, built with LangGraph and human-in-the-loop review.',
    tags: ['LangGraph', 'Human-in-the-loop', 'OpenAI', 'Chatbot'],
  },
  {
    id: 'ops-copilot',
    status: 'In production',
    kind: 'Forward Deployed · Aviation',
    title: 'Airport Ops Summary Copilot',
    summary:
      'OpenAI APIs inside flydubai\'s Departure Control System auto-generate flight and incident summaries.',
    tags: ['OpenAI', 'Next.js', 'Angular', 'Kafka'],
  },
  {
    id: 'baggage',
    status: 'AI use case',
    kind: 'Aviation',
    title: 'LLM Baggage Detection & Matching',
    summary:
      'LLM vision turns bag photos and descriptions into attributes, then ranks and explains delayed ↔ found bag matches.',
    tags: ['LLM vision', 'LangGraph', 'OpenAI'],
  },
  {
    id: 'support-rag',
    status: 'AI use case',
    kind: 'Forward Deployed · Logistics',
    title: 'Logistics Support Assistant (RAG)',
    summary:
      'RAG assistant answering shipment and policy questions from live data and SOPs, with cited sources.',
    tags: ['RAG', 'LangChain', 'OpenAI'],
  },
  {
    id: 'kiosk-assistant',
    status: 'AI use case',
    kind: 'Forward Deployed · Airport',
    title: 'Multilingual Check-in Assistant',
    summary:
      'Kiosk helper that answers passengers in 15+ languages and routes to an agent when needed.',
    tags: ['LangGraph', 'Guardrails', 'i18n'],
  },
];
